import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";

const err = (e) => e?.response?.data?.detail || "Request failed";
const TONE = { SENT: "text-emerald-700", BLOCKED: "text-amber-700", FAILED: "text-red-700", UNKNOWN: "text-red-700", PENDING: "text-slate-600", SENDING: "text-slate-600" };
const RETRY = ["FAILED", "BLOCKED", "UNKNOWN"];

export function NoticeRow({ n, onPreview, onDone }) {
  const retry = () => api.post(`/address-verified-notices/notices/${n.id}/retry`).then((r) => { toast.message(`Retry: ${r.data.status}`); onDone(); }).catch((e) => toast.error(err(e)));
  return (
    <div className="flex flex-wrap items-center gap-2 border-t border-slate-100 py-1 text-[12px]" data-testid={`avn-row-${n.id}`}>
      <span className="font-semibold">{n.order_code || n.order_id}</span>
      <span>{n.recipient_name} · v{n.version_no}</span>
      <span className="text-slate-500">{n.verified_at?.slice(0, 16).replace("T", " ")} UTC</span>
      <b className={TONE[n.status]} data-testid={`avn-status-${n.id}`}>{n.status}</b>
      {n.reason && <span className="text-slate-600" data-testid={`avn-reason-${n.id}`}>{n.reason}</span>}
      {n.recipients?.to?.length > 0 && <span className="font-mono text-[11px] text-slate-500">→ {n.recipients.to.join(", ")}{n.recipients.cc?.length ? ` (cc ${n.recipients.cc.join(", ")})` : ""}</span>}
      <button className="underline" onClick={() => onPreview(n.id)} data-testid={`avn-preview-${n.id}`}>Preview</button>
      {RETRY.includes(n.status) && <button className="rounded-full bg-amber-600 px-3 py-0.5 font-semibold text-white" onClick={retry} data-testid={`avn-retry-${n.id}`}>Retry</button>}
    </div>
  );
}

export function AddressVerifiedSection({ oid }) {
  const [st, setSt] = useState(null);
  const [html, setHtml] = useState("");
  const load = useCallback(() => api.get(`/address-verified-notices/orders/${oid}`).then((r) => setSt(r.data)).catch(() => setSt(null)), [oid]);
  useEffect(() => { load(); }, [load]);
  if (!st) return null;
  const preview = (id) => api.get(`/address-verified-notices/notices/${id}/preview`).then((r) => setHtml(r.data.html)).catch((e) => toast.error(err(e)));
  return (
    <section className="rounded-xl border border-slate-200 bg-white p-3 text-[12px]" data-testid="avn-order-section">
      <div className="mb-1 text-sm font-bold">Customer "Address verified" confirmation · <span data-testid="avn-order-switch">{st.switch.enabled ? "ON" : "OFF"}</span></div>
      <div className="text-slate-600">Sent to the customer logistics contacts above when an employee confirms their address through the secure link.</div>
      {st.notices.length ? st.notices.map((n) => <NoticeRow key={n.id} n={n} onPreview={preview} onDone={load} />) : <div className="mt-1 text-slate-500" data-testid="avn-order-empty">No confirmations on this order yet.</div>}
      {html && <iframe title="Address verified preview" srcDoc={html} sandbox="" className="mt-2 h-[560px] w-full rounded border border-slate-200" data-testid="avn-order-preview-frame" />}
    </section>
  );
}
